export default __webpack_public_path__ + "static/channels4_profile-b0241818d038f8a4091d4f0a01463449.jpg";